var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.21 27.306c4.873 0 9.966 1.083 15.263 3.236 5.283 2.167 7.932 4.988 7.947 8.476v10.57H2V39.002c0-3.473 2.649-6.309 7.946-8.461 5.283-2.153 10.376-3.236 15.264-3.236ZM24.99 0c3.32 0 6.15 1.187 8.52 3.592 2.372 2.39 3.55 5.235 3.55 8.538s-1.178 6.118-3.55 8.477c-2.37 2.36-5.215 3.531-8.52 3.531-3.304 0-6.149-1.172-8.52-3.53-2.37-2.36-3.549-5.19-3.549-8.478 0-3.287 1.178-6.133 3.55-8.538 2.37-2.39 5.2-3.592 8.52-3.592Z",
    fillRule: "evenodd"
  })));
};

export default SvgUser;